export default __webpack_public_path__ + "/image/uib-logo_2bcc0b8.svg";